import type { IconSvgObject } from './types';

const ContrastIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12.002", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 19.002C15.866 19.002 19 15.8679 19 12.002C19 8.13596 15.866 5.00195 12 5.00195V19.002Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ContrastIcon;
